import algoliasearch from 'algoliasearch/lite';
import { createInstantSearch } from 'react-instantsearch-core';
var InstantSearch = createInstantSearch(algoliasearch, {
  Root: 'div',
  props: {
    className: 'ais-InstantSearch__root'
  }
});
export default InstantSearch;


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch-dom/dist/es/widgets/InstantSearch.js
// module id = 966
// module chunks = 0 1 2 3 4 5 6 7 8